import React from "react";

function General() {
  return (
    <div className="flex flex-col items-center justify-center w-[100vw] h-screen fixed top-0">
      <h1 className="text-4xl">This page is still under development ...</h1>
    </div>
  );
}

export default General;
